function TextareaForm(props) {
    return (
        <>
            <label for="description" className={`block text-sm font-medium text-gray-700 mb-1 ${props.invalid && 'text-red-500'}`}>
                {props.label} {!props.optional && <span className="text-red-500">*</span>}
            </label>
            <textarea
                id={props.id}
                className={`w-full px-4 py-2 border-1 border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${props.invalid && 'text-red-500 border-red-500'}`}
                style={props.style}
                type={props.type}
                min={props.min}
                max={props.max}
                maxLength={props.maxLength}
                name={props.name}
                rows={props.rows}
                required={props.required}
                onBlur={props.onBlur}
                disabled={props.disabled}
                placeholder={props.placeholder}
                value={props.value}
                pattern={props.pattern}
                onChange={props.onChange}
                autoComplete={props.autoComplete}
                onInput={props.onInput}
            >
            </textarea>
        </>
    )
}

export default TextareaForm;